var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99997 0.333308C3.61876 0.333441 4.21215 0.579359 4.64964 1.01697L20.983 17.3503C21.4204 17.7879 21.6661 18.3813 21.6661 19C21.6661 19.6187 21.4204 20.2121 20.983 20.6496L4.64964 36.983C4.43439 37.2058 4.17692 37.3836 3.89224 37.5059C3.60757 37.6282 3.30139 37.6925 2.99157 37.6952C2.68175 37.6979 2.3745 37.6389 2.08774 37.5216C1.80098 37.4042 1.54046 37.231 1.32138 37.0119C1.1023 36.7928 0.929041 36.5323 0.811718 36.2455C0.694397 35.9588 0.635357 35.6515 0.63805 35.3417C0.640742 35.0319 0.705109 34.7257 0.827397 34.441C0.949684 34.1564 1.12745 33.8989 1.3503 33.6836L16.034 19L1.3503 4.31631C1.02408 3.98999 0.801934 3.57427 0.711944 3.12172C0.621953 2.66916 0.668159 2.20008 0.844722 1.77378C1.02129 1.34748 1.32028 0.983103 1.7039 0.726706C2.08753 0.470308 2.53855 0.333407 2.99997 0.333308Z",
    fill: "#15345A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.b73ed8c12951f62f35455bb78b44572b.svg";
export { ForwardRef as ReactComponent };